import * as React from 'react';
import DetailsCard from '../common/DetailsCard';
import BarChart from '../../BarChart';
import { replaceTokens } from '../../StringUtils';
import { normalizePayRange } from '../common/Helpers';
import strings from './strings';
import './style/index.scss';
export class RangeDistributionCard extends React.PureComponent {
    constructor(props) {
        super(props);
        RangeDistributionCard._positionStrings = RangeDistributionCard._positionStrings ||
            [
                strings.below,
                strings.bottom,
                strings.middle,
                strings.top,
                strings.above
            ];
    }
    static isValidData(rangeMin, rangeMax, value) {
        return rangeMin != null && rangeMax != null && value != null;
    }
    static _computeRangePosition(basePay, rangeMin, rangeMax) {
        if (basePay === null || rangeMin === null || rangeMax === null) {
            return 5;
        }
        if (basePay < rangeMin) {
            return 0;
        }
        else if (basePay > rangeMax) {
            return 4;
        }
        const oneQuarterRange = (rangeMax - rangeMin) / 4;
        const whichQuarter = (oneQuarterRange === 0) ?
            2 :
            Math.floor((basePay - rangeMin) / oneQuarterRange) + 1;
        if (whichQuarter === 1) {
            return 1;
        }
        else if (whichQuarter === 2 || whichQuarter === 3) {
            return 2;
        }
        else {
            return 3;
        }
    }
    render() {
        const { pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange, employeeName, rangeDistribution } = this.props;
        if (!RangeDistributionCard.isValidData(rangeMin, rangeMax, pay)) {
            return null;
        }
        const normalizedRange = normalizePayRange(pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange);
        const rangePosition = RangeDistributionCard._computeRangePosition(pay, normalizedRange.rangeMin, normalizedRange.rangeMax);
        if (rangePosition == null || rangePosition === 5) {
            return null;
        }
        const canRenderViz = rangeDistribution && rangeDistribution.length > 0;
        return (React.createElement(DetailsCard, { className: "range-distribution-card", title: strings.cardTitle },
            canRenderViz && this._renderRangeDistributionViz(rangePosition, rangeDistribution),
            this._renderRangeDistributionDescription(employeeName, rangePosition, rangeDistribution)));
    }
    static _computeCohortPercentages(rangeDistribution) {
        const modifiedDistribution = [
            rangeDistribution[0],
            rangeDistribution[1],
            rangeDistribution[2] + rangeDistribution[3],
            rangeDistribution[4],
            rangeDistribution[5]
        ];
        const totalCount = modifiedDistribution.reduce((val, acc) => acc + val, 0);
        return modifiedDistribution.map(val => totalCount ? Math.round(val / totalCount * 100) : 0);
    }
    _renderRangeDistributionDescription(firstName, rangePosition, rangeValues) {
        const outsideRange = rangePosition === 4 || rangePosition === 0;
        const subject = firstName || strings.thisEmployee;
        const part1 = rangeValues ?
            replaceTokens(outsideRange ?
                strings.descriptionOutRange :
                strings.descriptionInRange, subject, `${RangeDistributionCard._computeCohortPercentages(rangeValues)[rangePosition]}%`) :
            replaceTokens(outsideRange ?
                strings.descriptionOutRangeSingular :
                strings.descriptionInRangeSingular, subject);
        const part2 = outsideRange ?
            strings.descriptionPositionOutRange :
            strings.descriptionPositionInRange;
        return (React.createElement("div", { className: "range-distribution-card__desc" },
            React.createElement("span", { className: "sensitive-info" }, part1),
            React.createElement("span", { className: "range-distribution-card__desc-position" }, ` ${RangeDistributionCard._positionStrings[rangePosition].toLowerCase()} `),
            React.createElement("span", null, part2)));
    }
    _renderRangeDistributionViz(rangePosition, rangeDistribution) {
        const classNames = [
            'range-distribution-card-bar1 range-distribution-card__viz__bar--out-range',
            'range-distribution-card-bar2 range-distribution-card__viz__bar--in-range',
            'range-distribution-card-bar3 range-distribution-card__viz__bar--in-range',
            'range-distribution-card-bar4 range-distribution-card__viz__bar--in-range',
            'range-distribution-card-bar5 range-distribution-card__viz__bar--out-range'
        ];
        const rangeValues = RangeDistributionCard._computeCohortPercentages(rangeDistribution);
        const bars = RangeDistributionCard._positionStrings.map((label, index) => {
            const active = index === rangePosition;
            return {
                value: rangeValues[index],
                axisLabel: label,
                className: `${classNames[index]}${active ? '--active' : ''}`,
                label: active ? `${rangeValues[index]}%` : null
            };
        });
        return (React.createElement("div", { className: "range-distribution-card__viz" },
            React.createElement(BarChart, { bars: bars })));
    }
}
export default RangeDistributionCard;
